import axios from "axios";
import { constant } from "../constant";

// Create separate axios instances for different roles
export const adminAxios = axios.create({
  baseURL: constant.base_url1, // For Super Admin & Admin
});

export const coordinatorAxios = axios.create({
  baseURL: constant.base_url2, // For Coordinator
});

// Common interceptor for both instances
const setupInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        document.cookie = "userToken=; path=/;";
        window.location.href = "/";
      }
      return Promise.reject(error);
    }
  );
};

setupInterceptor(adminAxios);
setupInterceptor(coordinatorAxios);

// Set default for backward compatibility
axios.defaults.baseURL = constant.base_url1;

// Export both instances
// export { adminAxios, coordinatorAxios };

//Super Admin Panel API
export { GetAllCompany } from "./SuperAdminAPI";
export { CreateCompanyAPI } from "./SuperAdminAPI";
export { UpdateCompanyAPI } from "./SuperAdminAPI";

//Admin Panel API
export { UserLogin } from "./AdminAPI";
export { GetUserByToken } from "./AdminAPI";
export { GetAdminDashboard } from "./AdminAPI";
export { GetAllCounter } from "./AdminAPI";
export { CreateCounterAPI } from "./AdminAPI";
export { UpdateCounterAPI } from "./AdminAPI";
export { GetAllDepartment } from "./AdminAPI";
export { CreateDepartmentAPI } from "./AdminAPI";
export { UpdateDepartmentAPI } from "./AdminAPI";
export { GetAllUser } from "./AdminAPI";
export { GetAllSevice } from "./AdminAPI";
export { CreateServiceAPI } from "./AdminAPI";
export { UpdateServiceAPI } from "./AdminAPI";
export { CreateUserAPI } from "./AdminAPI";
export { UpdateUserAPI } from "./AdminAPI";
export { UpdateUserPasswordAPI } from "./AdminAPI";
export { UploadImage } from "./AdminAPI";
export { GetAllAdvertisement } from "./AdminAPI";
export { CreateAdvertisementAPI } from "./AdminAPI";
export { UpdateAdvertisementAPI } from "./AdminAPI";
export { GetCompanySettings } from "./AdminAPI";
export { UpdateCompanySettings } from "./AdminAPI";
export { GetAllDetailReport } from "./AdminAPI";
export { GetTokenTATReport } from "./AdminAPI";
export { UploadVedio } from "./AdminAPI";
export { GetAllSummaryReport } from "./AdminAPI";
export { UserMap } from "./AdminAPI";

//Coordinator Page API
export { GetToken } from "./CoordinatorAPI";
export { GetHoldToken } from "./CoordinatorAPI";
export { GetAllPendingToken } from "./CoordinatorAPI";
export { GetTokenCall } from "./CoordinatorAPI";
export { DeleteAllToken } from "./CoordinatorAPI";
export { CustomTokenCall } from "./CoordinatorAPI";
export { CompleteTokenStatus } from "./CoordinatorAPI";
export { GetDepartmentForCoordinator } from "./CoordinatorAPI";
export { GetRecallToken } from "./CoordinatorAPI";
export { GetSevice } from "./CoordinatorAPI";
export { TokenTransfer } from "./CoordinatorAPI";
export { CheckTokenValue } from "./CoordinatorAPI";
export { GetCompleted } from "./CoordinatorAPI";
export { GetTimeline } from "./CoordinatorAPI";
export { GetDepartmentCounter } from "./CoordinatorAPI";
export { GetDepartments } from "./CoordinatorAPI";
export { HoldTokenStatus } from "./CoordinatorAPI"